import React, { useEffect, useState } from "react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import {
  Card,
  CardBody,
  IconButton,
  Input,
  Spinner,
  Typography,
} from "@material-tailwind/react"
import { useHistory } from "react-router-dom"
import {
  BROKERCOMPANYDASHBOARD,
  CLIENT360AGGREGATES,
  GETALLINSURANCECOMPANIES,
  GETALLINTERMEDIARIESAGENT,
  GETALLINTERMEDIARIESBROKER,
  GETCOMPANYSTAFF,
  GETSUGAGENTS,
  GET_ALL_BROKER_STAFF,
} from "../../../GraphQl/queries"
import {
  ClientAggregateType,
  InsuranceCompanyType,
  InsuranceDahboardType,
  IntermediariesAgentType,
  IntermediariesSubAgentType,
  IntermediariesBrokerType,
  IntermediariesStaffType,
  newCompanyStaff,
} from "../../../types/query"
import { useQuery } from "@apollo/client"
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai"
import { AgentDetail, DetailDrawer, StaffDetail } from "../../../components"
import BrokerDetail from "../../../components/Details/broker-detail"
import { UserType } from "../../../types/user"
import { DEFAULTPRIMARYCOLOR } from "../../../util"
import { StaffResponseType } from "../staffs"
import { agentDummyData, StaffDummyData } from "../../../util/dummy"
import GeneralPagination from "../../../components/paginations/GeneralPagination"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { getColorCode } from "../../../colorCodes"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"

type SubAgent = {
  __typename: "sub_agents"
  active_status: boolean
  agent_code: string
  agent_meta_data: {
    address: string
    id_type: string
    branch_id: string
    id_number: string
    tin_number: string
    division_id: string
    bank_details: {
      code: string
      branch: string
      bank_name: string
      acct_number: string
      account_name: string
    }
    momo_details: {
      number: string
      network: string
    }
    guarantor_details: {
      name: string
      phone: string
      address: string
      id_number: string
    }
    intermediary_type: string
    intermediary_type_code: string
    nic_registration_number: string
    preferred_payment_method: string
  }
  balance: string
  cash_limit: number
  created_at: string // You may want to convert this to `Date` if working with date objects
  email: string
  id: string
  first_name: string
  is_first_time: boolean
  last_name: string
  phone_number: string
  role_id: string
  updated_at: string // Convert to `Date` if necessary
}

type CompanyStaff = {
  __typename: "company_staff"
  phone_number_two: string
  phone_number_one: string
  created_at: string // Convert to `Date` if necessary
  tin_number: string
  staff_number: string
  name: string
  momo_details: {
    number: string
    network: string
  }
  is_first_time: boolean
  cash_limit: number
  guarantor_details: {
    name: string
    phone: string
    address: string
    id_number: string
  }
  email: string
  id: string
  id_number: string
  id_type: string
  active_status: boolean
  bank_details: {
    code: string
    branch: string
    bank_name: string
    acct_number: string
    account_name: string
  }
  preferred_payment_channel: string
  division_id: string
  dob: string // Convert to `Date` if necessary
  role_id: string
  company_role: {
    __typename: "company_role"
    id: string
    name: string
  }
  branch: {
    __typename: "branch"
    id: string
    name: string
  }
}

const ClientView = () => {
  const filterOptions = ["Sub Agents", "Staff"]
  const [selectedfilter, setFilter] = useState("Staff")
  const history = useHistory()
  const [searchText, setSearchText] = useState("")
  const [activePage, setActivePage] = useState(1)
  const [open, setOpen] = useState(false)
  const [openDrawer, setOpenDrawer] = React.useState(false)
  const [selectedRow, setSelectedRow] = useState<
    | IntermediariesStaffType
    | IntermediariesBrokerType
    | IntermediariesAgentType
    | StaffResponseType
    | undefined
  >()

  const {
    companyId,
    token,
    user: stateUser,
  } = useSelector((state: RootState) => state.auth)
  const {
    data,
    loading: loadingAggregate,
    refetch,
  } = useQuery<{ sub_agents: SubAgent[] }>(GETSUGAGENTS, {
    variables: {
      id: companyId,
    },
  })

  const {
    data: borkerData,
    loading: loadingBroker,
    refetch: refetchbroker,
  } = useQuery<{ intemediary: IntermediariesBrokerType[] }>(
    GET_ALL_BROKER_STAFF,
    {
      variables: {
        company_id: companyId,
      },
    }
  )


  const {
    data: staff,
    loading: loadingStaff,
    refetch: refreshStaff,
  } = useQuery<{
    company_staff: CompanyStaff[]
  }>(GETCOMPANYSTAFF, {
    variables: {
      company_id: companyId,
    },
  })

  const handleInsuranceSearch = (e: any) => {
    setSearchText(e.target.value)
    setActivePage(1)
  }

  const handleBrokerSearch = (e: any) => {
    setSearchText(e.target.value)
    setActivePage(1)
  }

  const handleAgentSearch = (e: any) => {
    setSearchText(e.target.value)
    setActivePage(1)
  }

  const handleSubAgentSearch = (e: any) => {
    setSearchText(e.target.value)
    setActivePage(1)
  }

  const filterStaffData = (filter: newCompanyStaff) => {
    const isTextMatch =
      filter?.name?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      
      filter?.phone_number_one
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.staff_number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.email?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.company_role?.name.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.momo_details?.network
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.bank_details?.bank_name
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.bank_details?.branch
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.staff_number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.momo_details?.number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.email?.toLowerCase()?.includes(searchText?.toLowerCase())
    return isTextMatch
  }

  const filterAgentData = (filter: IntermediariesSubAgentType) => {
    const isTextMatch =
      filter?.first_name?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.last_name?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.intermediary_type
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.branch_code?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.insurer_company?.name
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.address?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.momo_details?.network
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.bank_details?.bank_name
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.phone_number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.bank_details?.branch
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.nic_registration_number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.email?.toLowerCase()?.includes(searchText?.toLowerCase())
    return isTextMatch
  }
  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const filterSelectFxn = (selectedItem: string) => {
    let paginatedData: IntermediariesAgentType[] | newCompanyStaff[]

    if (selectedItem === "Sub Agents") {
      paginatedData = (data?.sub_agents as any)?.filter(filterAgentData)
    } else if (selectedItem === "Staff") {
      paginatedData = (staff?.company_staff as any)?.filter(filterStaffData)
    } else {
      paginatedData = (data?.sub_agents as any)?.filter(filterAgentData)
    }
    return paginatedData
  }
  const totalItems = filterSelectFxn(selectedfilter)

  useEffect(() => {
    if (searchText || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [searchText, itemsPerPage])

  const endOffset = currentPage + itemsPerPage
  const paginatedData = totalItems?.slice(currentPage, endOffset)

  const onChangeFilter = (value: string) => {
    if (value === "Sub Agents") {
      refetch()
    } else if (value === "Staff") {
      refreshStaff()
    }
    setFilter(value)
  }

  const rowClick = (
    value:
      | IntermediariesStaffType
      | IntermediariesBrokerType
      | IntermediariesAgentType
      | StaffResponseType
      | undefined
  ) => {
    setSelectedRow(value)
    setOpen(true)
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])

  return (
    <>
      <DetailDrawer
        onClose={() => setOpen(false)}
        open={open}
        title={
          selectedfilter === "Sub Agents"
            ? "Agent Detail"
            : selectedfilter === "Staff"
            ? "Staff Detail"
            : ""
        }
        children={
          selectedfilter === "Sub Agents" ? (
            <AgentDetail
              content={selectedRow as IntermediariesStaffType | any}
            />
          ) : selectedfilter === "Staff" ? (
            <StaffDetail content={selectedRow as StaffResponseType} />
          ) : null
        }
        size={450}
      />
      <CustomHeader title="client" />

      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2 md:lg:gap-3 lg:gap-5">
        <Card className="bg-brand-danger rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
          <div className="flex flex-row justify-between text-center">
            <div>
              <Typography className="text-3xl font-bold text-white capitalize tracking-wider">
                {loadingStaff ? (
                  <Spinner className="mb-2 text-white" />
                ) : (
                  staff?.company_staff?.length
                )}
              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                staff
              </Typography>
            </div>
          </div>
        </Card>

        <Card className="bg-brand-teal rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
          <div className="flex flex-row justify-between text-center">
            <div>
              <Typography className="text-3xl font-bold text-white capitalize tracking-wider">
                {loadingAggregate ? (
                  <Spinner className="mb-2 text-white" />
                ) : (
                  data?.sub_agents?.length
                )}
              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                Sub-agents
              </Typography>
            </div>
          </div>
        </Card>
      </div>

      <div className="mt-5 flex flex-col md:flex-row lg:flex-row gap-2 items-center justify-between bg-white p-3 rounded-lg">
        <div className="flex flex-col md:flex-row lg:flex-row gap-3  w-full">
          <div className="flex flex-row items-center w-full lg:w-1/2 mr-3">
            <Typography className="w-28">Filter by</Typography>
            <select
              value={selectedfilter}
              onChange={(e) => onChangeFilter(e.target.value)}
              className="h-10 capitalize bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option selected disabled>
                Select filter
              </option>
              {filterOptions?.map((item) => (
                <option
                  className="capitalize"
                  value={item}
                  key={item}
                  label={item}
                >
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="w-full">
            <Input
              crossOrigin="anonymous"
              label="Search"
              value={searchText}
              onChange={
                selectedfilter === "Agents"
                  ? handleAgentSearch
                  : selectedfilter === "Staff"
                  ? handleBrokerSearch
                  : selectedfilter === "Sub Agents"
                  ? handleSubAgentSearch
                  : handleInsuranceSearch
              }
              icon={<i className="fas fa-search text-base"></i>}
            />
          </div>
        </div>
      </div>

      <div className="mt-10">
        <CardBody className="shadow-sm overflow-x-scroll px-0 py-0  rounded-3xl">
          <div className="bg-black pt-5">
            <Typography
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              variant="h6"
              className="px-4 pb-4 font-bold leading-none opacity-70"
            >
              List of All {selectedfilter}
              <span
              className="text-white text-sm bg-admin-red p-1 rounded-m">{selectedfilter.length}</span>
            </Typography>
          </div>
          {selectedfilter === "Staff" ? (
            <table className=" bg-white w-full min-w-max table-auto">
              <thead className="">
                <tr>
                  {[
                    "Staff number",
                    "Full Name",
                    "Email",
                    "Phone Number",
                    "Role",
                    "Momo Details",
                    "Bank Details",
                  ].map((head) => (
                    <th
                      key={head}
                      className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                    >
                      <Typography
                        color="black"
                        className="font-normal text-sm text-black leading-none opacity-70 capitalize"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData?.map((item: any, index: number) => {
                  const isLast = index === paginatedData?.length - 1
                  const classes = isLast
                    ? "px-2 py-2  text-center"
                    : "px-2 py-2 border-b-2 border-blue-gray-50 text-center"

                  return (
                    <tr
                      onClick={() => rowClick(item)}
                      key={item?.id + index.toString()}
                      className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                    >
                     
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as CompanyStaff)?.staff_number}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as CompanyStaff)?.name}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as CompanyStaff)?.email}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as CompanyStaff)?.phone_number_one}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as CompanyStaff)?.company_role?.name}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <div className="flex flex-col gap-2 ">
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Network:{" "}
                            <span className="font-normal">
                              {(item as CompanyStaff)?.momo_details?.network}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Number:{" "}
                            <span className="font-normal">
                              {(item as CompanyStaff)?.momo_details?.number}
                            </span>
                          </Typography>
                        </div>
                      </td>

                      <td className={classes}>
                        <div className="flex flex-col gap-2">
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Bank:{" "}
                            <span className="font-normal">
                              {(item as CompanyStaff)?.bank_details?.bank_name}
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Branch:{" "}
                            <span className="font-normal">
                              {(item as CompanyStaff)?.bank_details?.branch}
                            </span>
                          </Typography>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <table className=" bg-white w-full min-w-max table-auto">
              <thead className="">
                <tr>
                  {[
                    "Intermediary type",
                    "Full Name",
                    "Email",
                    "Phone Number",
                   
                    "Momo Details",
                    "Bank Details",
                  ].map((head) => (
                    <th
                      key={head}
                      className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                    >
                      <Typography
                        color="black"
                        className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData?.map((item: any, index: number) => {
                  const isLast = index === paginatedData?.length - 1
                  const classes = isLast
                    ? "px-2 py-2  text-center"
                    : "px-2 py-2 border-b-2 border-blue-gray-50 text-center"

                  return (
                    <tr
                      onClick={() => rowClick(item)}
                      key={item?.id + index.toString()}
                      className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                    >
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize "
                        >
                          {
                            (item as SubAgent)?.agent_meta_data
                              ?.intermediary_type_code
                          }
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as SubAgent)?.first_name + " "+(item as SubAgent)?.last_name}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as SubAgent)?.email}
                        </Typography>
                      </td>

                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-xs capitalize"
                        >
                          {(item as SubAgent)?.phone_number}
                        </Typography>
                      </td>
                     
                      <td className={classes}>
                        <div className="flex flex-col gap-2">
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Network:{" "}
                            <span className="font-normal">
                              {
                                (item as SubAgent)?.agent_meta_data
                                  ?.momo_details?.network
                              }
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Number:{" "}
                            <span className="font-normal">
                              {
                                (item as SubAgent)?.agent_meta_data
                                  ?.momo_details?.number
                              }
                            </span>
                          </Typography>
                        </div>
                      </td>
                      <td className={classes}>
                        <div className="flex flex-col gap-2">
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Bank:{" "}
                            <span className="font-normal">
                              {
                                (item as SubAgent)?.agent_meta_data
                                  ?.bank_details?.bank_name
                              }
                            </span>
                          </Typography>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold text-xs capitalize "
                          >
                            Branch:{" "}
                            <span className="font-normal">
                              {
                                (item as SubAgent)?.agent_meta_data
                                  ?.bank_details?.branch
                              }
                            </span>
                          </Typography>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )}

          {loadingStaff || loadingBroker ? (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-1o h-10" />
            </div>
          ) : null}
        </CardBody>
        {paginatedData?.length !== 0 && (!loadingStaff || !loadingBroker) && (
          <PerPageAndPagination
            total={totalItems?.length!}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={itemsPerPage}
            setPerPage={setItemsPerPage}
          />
        )}
      </div>
    </>
  )
}

export default ClientView
